import { useTranslate } from "hooks/useTranslate";

export const useGetWidgetTitleByType = (widgetType) => {
  const translate = useTranslate();
  switch (widgetType) {
    case "projects":
      return translate("MY_PROJECTS");
    case "products":
      return translate("LEFT_SIDEBAR_PRODUCTS");
    case "wizards":
      return translate("LEFT_SIDEBAR_WIZARDS");
    case "library":
      return translate("LEFT_SIDEBAR_LIBRARY");
    default:
      return "";
  }
};

export const useGetWidgetDescriptionsByType = (widgetType) => {
  const translate = useTranslate();
  switch (widgetType) {
    case "products":
      return [
        translate("PRODUCT_CONFIGURATOR_PRODUCT_FINDER"),
        translate("PRODUCT_CONFIGURATOR_CONFIGURATION"),
        translate("PRODUCT_CONFIGURATOR_TECHNICAL_DESIGN"),
      ];
    case "wizards":
      return [
        translate("GUIDED_PRODUCT_SELECTION"),
        translate("SYSTEM_DESIGN"),
      ];
    case "library":
      return [translate("TROX_TEMPLATES"), translate("CUSTOM_LIBRARY")];
    default:
      return [];
  }
};
